import styled from '@emotion/styled';

export const Button = styled.button`
  background-color: ${(props) => props.buttonColor};
  color: ${(props) => props.textColor};
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px 29px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
`;
